import { Routes } from '@angular/router';
import { RouteComponent } from './screens/route/route';
import { DeliveryDetailsComponent } from './screens/delivery-details/delivery-details';
import { Home } from './screens/home/home';
import { CreateRouteScreen } from './screens/create-route-screen/create-route-screen';
import { RoutesViewScreen } from './screens/routes-view-screen/routes-view-screen';
import { SuccessComponent } from './payment/success/success.component';
import { CartViewComponent } from './payment/cart-view/cart-view.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { SubPricingComponent } from './payment/sub-pricing/sub-pricing.component';
import { SettingsComponent } from './payment/settings/settings.component';
import { RegisterComponent } from './auth/register/register.component';
import { UserManagementComponent } from './auth/user-management/user-management.component';
import { InstanceComponent } from './auth/instance/instance.component';
import { UpdateEmailComponent } from './auth/update-email/update-email.component';
import { AccountDisabledComponent } from './auth/account-disabled/account-disabled.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { UpdatePasswordComponent } from './auth/update-password/update-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { TokenVerificationComponent } from './auth/token-verification/token-verification.component';
import { ErrorPageComponent } from './commons/error-page/error-page.component';
import { LoginComponent } from './auth/login/login.component';
import { MemberLoginComponent } from './auth/member-login/member-login.component';

export const routes: Routes = [
    { path: '', component: Home },
    { path: 'route', component: RouteComponent, canActivate: [AuthGuardService], data: { instanceRequired: true } },
    { path: 'delivery', component: DeliveryDetailsComponent, canActivate: [AuthGuardService] },
    { path: 'create-route', component: CreateRouteScreen, canActivate: [AuthGuardService], data: { instanceRequired: true } },
    { path: 'routes-view', component: RoutesViewScreen, canActivate: [AuthGuardService], data: { instanceRequired: true } },

    // finance components
    { path: 'success', component: SuccessComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
    { path: 'cart-view', component: CartViewComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
    { path: 'sub-pricing', component: SubPricingComponent },
    { path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true, roles: ['admin'] } },

    // auth components
    { path: 'register', component: RegisterComponent, canActivate: [AuthGuardService], data: { loggedOutAccessOnly: true } },
    { path: 'login', component: LoginComponent, canActivate: [AuthGuardService], data: { loggedOutAccessOnly: true } },
    { path: 'member-login', component: MemberLoginComponent, canActivate: [AuthGuardService], data: { loggedOutAccessOnly: true } },
    { path: 'user-management', component: UserManagementComponent, canActivate: [AuthGuardService], data: { roles: ['admin'] } },
    { path: 'instance-management', component: InstanceComponent, data: { loggedInAccessOnly: true } },
    { path: 'update-email', component: UpdateEmailComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
    { path: 'account-disabled', component: AccountDisabledComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
    { path: 'email-confirmation', component: EmailVerificationComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'update-password', component: UpdatePasswordComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'verification', component: TokenVerificationComponent },

    { path: '*', component: ErrorPageComponent },


];
